import { render, staticRenderFns } from "./TrainingZone.vue?vue&type=template&id=218b6aaf&scoped=true"
import script from "./TrainingZone.vue?vue&type=script&lang=js"
export * from "./TrainingZone.vue?vue&type=script&lang=js"
import style0 from "./TrainingZone.vue?vue&type=style&index=0&id=218b6aaf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "218b6aaf",
  null
  
)

export default component.exports